module.exports = __webpack_public_path__ + "img/album06_06.1b8a50aa.jpg";